import React from "react";
import {useSelector} from "react-redux";
import {useParams} from "react-router";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {useSearchFormSubmit} from "../../../search/hooks/use_search_form_submit";
import {useAppSelector} from "../../../store/hooks";
import {IOfferModalQueryParams, OfferModal} from "../../components/offer_modal/OfferModal";
import {useOfferModalOffers} from "../../hooks/use_offer_modal_offers";
import {IOfferModalName} from "../../types/OfferModalName";
import {OfferListSubType} from "../types/OfferListSubType";

const modalName: IOfferModalName = "mainOfferModal";

export function DefaultOfferListingModal() {
    const params = useParams<{offerListSubType?: OfferListSubType}>();

    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);
    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const modalListingPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const modalListingPageSize = useSelector((state: IRPStore) => state.offerList.list.page_size);
    const privilegedOffers = useSelector((state: IRPStore) => state.offerList.list.privileged_offers);

    const modalQueryParams: IOfferModalQueryParams = {
        listingPage: modalListingPage,
        listingPageSize: modalListingPageSize
    };

    const listingQueryParams = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const modalQuery = {...listingQueryParams, page_size: pageSize, page: page};
    const defaultModalListingQuery = useOfferModalOffers(!isOpen, modalQuery, params.offerListSubType, privilegedOffers);

    const searchFormSubmit = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: listingQueryParams,
        listFriendlyLink: ({friendlySlug, offerListSubFilterSlug}) => {
            if (offerListSubFilterSlug) {
                return rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug});
            }

            return rpAppLink.offer.listFriendly({friendlySlug});
        },
        abroadListFriendlyLink: (params) => {
            return rpAppLink.offer.listFriendlyAbroad(params);
        }
    });

    return (
        <OfferModal
            modalName={modalName}
            offersQuery={defaultModalListingQuery}
            initialQueryParams={modalQueryParams}
            onClose={(modalConfig) => {
                searchFormSubmit({
                    ...searchFormValues,
                    floor_choices: modalConfig.filters.floor_choices,
                    area: modalConfig.filters.area,
                    rooms: modalConfig.filters.rooms
                });
            }}
        />
    );
}
import React from "react";
import {useSelector} from "react-redux";
import {useParams} from "react-router";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {useSearchFormSubmit} from "../../../search/hooks/use_search_form_submit";
import {useAppSelector} from "../../../store/hooks";
import {IOfferModalQueryParams, OfferModal} from "../../components/offer_modal/OfferModal";
import {useOfferModalOffers} from "../../hooks/use_offer_modal_offers";
import {IOfferModalName} from "../../types/OfferModalName";
import {OfferListSubType} from "../types/OfferListSubType";

const modalName: IOfferModalName = "mainOfferModal";

export function DefaultOfferListingModal() {
    const params = useParams<{offerListSubType?: OfferListSubType}>();

    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);
    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const modalListingPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const modalListingPageSize = useSelector((state: IRPStore) => state.offerList.list.page_size);
    const privilegedOffers = useSelector((state: IRPStore) => state.offerList.list.privileged_offers);

    const modalQueryParams: IOfferModalQueryParams = {
        listingPage: modalListingPage,
        listingPageSize: modalListingPageSize
    };

    const listingQueryParams = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const modalQuery = {...listingQueryParams, page_size: pageSize, page: page};
    const defaultModalListingQuery = useOfferModalOffers(!isOpen, modalQuery, params.offerListSubType, privilegedOffers);

    const searchFormSubmit = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: listingQueryParams,
        listFriendlyLink: ({friendlySlug, offerListSubFilterSlug}) => {
            if (offerListSubFilterSlug) {
                return rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug});
            }

            return rpAppLink.offer.listFriendly({friendlySlug});
        },
        abroadListFriendlyLink: (params) => {
            return rpAppLink.offer.listFriendlyAbroad(params);
        }
    });

    return (
        <OfferModal
            modalName={modalName}
            offersQuery={defaultModalListingQuery}
            initialQueryParams={modalQueryParams}
            onClose={(modalConfig) => {
                searchFormSubmit({
                    ...searchFormValues,
                    floor_choices: modalConfig.filters.floor_choices,
                    area: modalConfig.filters.area,
                    rooms: modalConfig.filters.rooms
                });
            }}
        />
    );
}
